<template>
  <div class="content">
    <div v-html="content"></div>
  </div>
</template>
<script>
import { getQueryString } from '../../../common/util'
export default {
  data() {
    return {
      code:null,
      content:""
    };
  },
  mounted() {
    this.code = getQueryString("code");
    this.getContent(this.code);
  },
  methods: {
    getContent(code){
      let params = {
        code:code
      }
      this.http.POST("/ruleDesc/ruleDescDetail",params).then(result => {
        if(result._code === '000000'){
          this.content = result._data.content;
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
.content{
  min-height: 300px;
  padding: 15px;
  font-family: PingFang,Lucida Grande,Arial,Lucida Sans Unicode,Helvetica Neue,Hiragino Sans GB,Microsoft Yahei,Sans-serif,San Francisco UI!important;
}
</style>
